export default __webpack_public_path__ + "static/media/group5126.6b8d1cb3.png";